interface CheckPledgeRequest {
    name: string,
    email: string,
    amount: number,
}

export function saveCheckPledge(checkPledgeRequest: CheckPledgeRequest): JQuery.jqXHR {
    return $.ajax({
        url: `${secureBaseURL}donors/daf-giving-hub/save-check-pledge`,
        type: 'POST',
        data: JSON.stringify(checkPledgeRequest),
        contentType: 'application/json',
        // withCredentials is necessary to pass cookies, since this is a cross-origin request
        xhrFields: { withCredentials: true },
    });
}
